export default __webpack_public_path__ + "static/media/03.909f6886.jpg";